var _circle, _rect, _stop, _stop2, _stop3, _stop4, _stop5, _stop6, _stop7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgInstagram(props) {
  var _id2 = useUniqueInlineId();
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#".concat(_id, ")")
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#".concat(_id2, ")")
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.686,
    cy: 16.772,
    r: 4.334,
    stroke: "#fff",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.751,
    y: 7,
    width: 18.497,
    height: 18.916,
    rx: 4,
    stroke: "#fff",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: _id,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-11.51971 -40.32005 59.97152 -17.13427 27.04 36.32)"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    offset: 0.198,
    stopColor: "#F50B5E"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DF0897"
  })), _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    stopColor: "#962FBF"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#4F5BD5"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: _id2,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-54.972 36.114 5.697) scale(20.9068 22.868)"
  }, _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#FEDA75"
  })), _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#FA7E1E"
  })), _stop7 || (_stop7 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA7E1E",
    stopOpacity: 0
  })))));
}
export default SvgInstagram;